import { render, staticRenderFns } from "./ReceiptItemLocationModal.vue?vue&type=template&id=f6020a00&scoped=true"
import script from "./ReceiptItemLocationModal.vue?vue&type=script&lang=js"
export * from "./ReceiptItemLocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6020a00",
  null
  
)

export default component.exports